import {Component, Inject} from '@angular/core';
import {AbstractProdForm, ProdFormField, ProdFormFieldType, ProdFormValidators, RequiredValidator, MustMatchValidator} from "prod-form";
import {ProdDialogService, ProdDialogData} from 'prod-dialog';
import {UserService} from "../../services/user.service";
import {take} from "rxjs";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {AuthenticationService} from "../../services/authentication.service";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html'
})
export class ChangePasswordComponent extends AbstractProdForm {
  title: string = this.translate.instant('change_password.title');
  formValidators: ProdFormValidators = new ProdFormValidators([new MustMatchValidator('newPassword', 'confirmPassword', this.translate.instant('change_password.new_password'))])
  fields: ProdFormField[] = [
    ProdFormField.create({
      type: ProdFormFieldType.PASSWORD,
      name: 'currentPassword',
      label: this.translate.instant('change_password.current_password'),
      validators: new ProdFormValidators([new RequiredValidator()])
    }),
    ProdFormField.create({
      type: ProdFormFieldType.PASSWORD,
      name: 'newPassword',
      label: this.translate.instant('change_password.new_password'),
      validators: new ProdFormValidators([new RequiredValidator()])
    }),
    ProdFormField.create({
      type: ProdFormFieldType.PASSWORD,
      name: 'confirmPassword',
      label: this.translate.instant('change_password.confirm_password'),
      validators: new ProdFormValidators([new RequiredValidator()])
    }),
  ];

  constructor(public dialogRef: MatDialogRef<ChangePasswordComponent>,
              @Inject(MAT_DIALOG_DATA) public dialogData: ProdDialogData,
              private userService: UserService,
              private dialogService: ProdDialogService,
              private authenticationService: AuthenticationService,
              private translate: TranslateService) {
    super();
  }

  ngOnInit(): void {
  }

  override post(data) {
    this.userService.changePassword(data.currentPassword, data.newPassword, data.confirmPassword)
      .pipe(take(1)).subscribe(res => {
        if (res['success']) {
          this.authenticationService.setRequireChangePasswordFalse();
          this.dialogRef.close();
          this.dialogService.alert({
            message: this.translate.instant('change_password.success_message'),
            title: this.translate.instant('general.success')
          })
        }
    });
  }
}
